import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Flashlight } from '@bibliocommons/deprecated-base-icons';
import { ExpandablePanel } from '@bibliocommons/deprecated-expandable';
import { didNotFindOptionsShape } from '@bibliocommons/bc-prop-types';

import { CHAT_WIDGET_ID } from 'app/constants/LibraryConstants';
import ChatWidgetButton from '../ChatWidgetButton';
import DidNotFind from '../DidNotFind';

import './DidNotFindExpandablePanel.scss';

function renderTriggerContent() {
  return <FormattedMessage id="did_not_find_discover" />;
}

function renderChatWidgetButton(chatWidgetId) {
  if (!chatWidgetId) {
    return null;
  }

  return (
    <span className="did-not-find-collapible-chat-widget">
      <ChatWidgetButton widget={chatWidgetId} />
    </span>
  );
}

function renderHeader(chatWidgetId) {
  return (
    <div className="did-not-find-heading-content">
      <div className="panel-title">
        <Flashlight />
        <FormattedMessage id="did_not_find_heading" />
      </div>
      {renderChatWidgetButton(chatWidgetId)}
    </div>
  );
}

export default function DidNotFindExpandablePanel({ query, didNotFindOptions, chatWidgetId }) {
  return (
    <ExpandablePanel
      className="did-not-find-expandable-panel"
      renderHeaderContent={() => renderHeader(chatWidgetId)}
      renderExpandButtonLabel={() => renderTriggerContent()}
    >
      <DidNotFind query={query} didNotFindOptions={didNotFindOptions} />
    </ExpandablePanel>
  );
}

DidNotFindExpandablePanel.defaultProps = {
  chatWidgetId: null
};

DidNotFindExpandablePanel.propTypes = {
  chatWidgetId: PropTypes.oneOf(Object.values(CHAT_WIDGET_ID)),
  didNotFindOptions: didNotFindOptionsShape,
  query: PropTypes.string
};
